// extracted by mini-css-extract-plugin
export default {"navigation__navLink":"navigation__navLink-JkSdI","horizontalNav":"horizontalNav-K6bCr","blackAndWhite":"blackAndWhite-Jj5BV"};